/**
 * Maps a sanitized CMS breadcrumb entry to ordered link data.
 * Curriculum-service turns `routeCollection` into `route`.
 * @param {Object} breadcrumb
 * @param {Array} [breadcrumb.route]
 * @returns {Array<{displayTitle: string, url: string}>}
 */
export const getBreadcrumbLinks = breadcrumb => {
  const routes = Array.isArray(breadcrumb?.route) ? breadcrumb.route : []

  return routes.reduce((links, route) => {
    const displayTitle =
      typeof route?.displayTitle === 'string' ? route.displayTitle.trim() : ''
    const url = typeof route?.url === 'string' ? route.url.trim() : ''

    if (!displayTitle || !url) {
      return links
    }

    return [
      ...links,
      {
        displayTitle,
        url,
      },
    ]
  }, [])
}
